import { useEffect } from 'react';
import { useEntityList, CATALOG_FILTER_EXISTS } from '@backstage/plugin-catalog-react';

class TechDocsFilter {
  getCatalogFilters() {
    return {
      "metadata.annotations.backstage.io/techdocs-ref": CATALOG_FILTER_EXISTS
    };
  }
}
const TechDocsPicker = () => {
  const { updateFilters } = useEntityList();
  useEffect(() => {
    updateFilters({
      techdocs: new TechDocsFilter()
    });
  }, [updateFilters]);
  return null;
};

export { TechDocsPicker };
//# sourceMappingURL=TechDocsPicker.esm.js.map
